import type { ArticleListResponse } from './article-cards.interface';

const DEFAULT_API_URL = '/bin/mhprojects/ecomm/articlelist';

/**
 * Fetches a page of articles from the AEM ArticleListServlet.
 *
 * @param apiUrl    - Servlet endpoint (defaults to DEFAULT_API_URL; overridable via the `api-url` attribute for testing).
 * @param displayFormat - One of: 'cards' | 'manual' | 'featured' | 'textHoriz' | 'textVert'.
 * @param tags      - Comma-separated tag values. Used by list modes (cards/textHoriz/textVert); ignored by servlet for featured/manual.
 * @param articlePaths - Comma-separated JCR paths. Used by featured (1 path) and manual (up to 3 paths); ignored for list modes.
 * @param page      - 1-based page number.
 * @param perPage   - Number of articles per page (perRow × numRows).
 * @throws {Error} when the HTTP response is not OK.
 */
export async function fetchArticles(
  apiUrl: string = DEFAULT_API_URL,
  displayFormat: string,
  tags: string,
  articlePaths: string,
  page: number,
  perPage: number,
): Promise<ArticleListResponse> {
  const params = new URLSearchParams({
    tag: tags,
    displayFormat,
    articlePaths,
    page: String(page),
    perPage: String(perPage),
  });

  const response = await fetch(`${apiUrl}?${params}`, { method: 'GET' });

  if (!response.ok) {
    throw new Error(`[mhecomm-article-cards] fetch failed: ${response.status} ${response.statusText}`);
  }

  return response.json() as Promise<ArticleListResponse>;
}
